module.exports = __webpack_public_path__ + "img/oddnary-variation-2.c767cc9c.jpg";